import { Button } from '../Input2';
import { General } from '../StrokeIcons';
import Popup, { PopupProps } from './Popup';

type MergeHubspotContactPopupProps = PopupProps & {
  onClose: () => void;
  onDelete: () => void;
};

export default function MergeHubspotContactPopup({ onClose, onDelete }: MergeHubspotContactPopupProps) {
  return (
    <Popup onClose={onClose} className="max-w-lg">
      <h2 className="text-xl font-bold dark:text-gray-100">Are you sure?</h2>
      <p className="dark:text-gray-300">
        This will match your Poseidon contact to this{' '}
        <General.HubSpotIcon className="relative inline-block size-4 text-[#f7761f]" />
        <strong className="text-[#f7761f]">HubSpot</strong> contact and fill in any empty fields in{' '}
        <General.HubSpotIcon className="relative inline-block size-4 text-[#f7761f]" />
        <strong className="text-[#f7761f]">HubSpot</strong> with data from Poseidon. Existing values will not be
        overwritten.
      </p>
      <Button color="blue" onClick={onDelete}>
        Yes, match to the HubSpot contact
      </Button>
    </Popup>
  );
}
